export class EcommerceCartSettingModel {
    constructor(setting) {
        const { uuid, subcategorized, additionalTax, additionalTaxType, addressInputType, deliveryFeeType, emailNotifRecipient, expiration, expirationDateType, freeShippingRequiredAmount, locationScope, chargeDeliveryFeeFrom, requiredAmount, shipping, enableProductLocationAvailability, digitalProduct, } = setting;
        this.uuid = uuid;
        this.subcategorized = subcategorized;
        this.additionalTax = additionalTax;
        this.additionalTaxType = additionalTaxType;
        this.addressInputType = addressInputType;
        this.addressInputType = addressInputType;
        this.deliveryFeeType = deliveryFeeType;
        this.emailRecipients = emailNotifRecipient;
        this.expiration = expiration || 0;
        this.expirationDateType = expirationDateType;
        this.freeShippingAmount = freeShippingRequiredAmount;
        this.locationScope = locationScope;
        this.chargeDeliveryFeeFrom = chargeDeliveryFeeFrom;
        this.cartRequiredAmount = requiredAmount;
        this.shipping = shipping;
        this.enableProductLocationAvailability = enableProductLocationAvailability;
        this.digitalProduct = digitalProduct;
    }
    recipientAsTags() {
        const recipients = this.emailRecipients;
        if (recipients) {
            return recipients.split(',');
        }
        return [];
    }
}
